// extracted by mini-css-extract-plugin
module.exports = {"avatar":"e_Mfb","fallback":"e_Nfb","s40":"e_Ofb","s32":"e_Pfb"};